<template>
  <div>
    <v-card>
      <v-card-title>
        <h2>WESERVE ADVERTISING</h2>
        <v-divider vertical class="mx-3"></v-divider
        ><v-btn
          color="primary"
          class="black--text elevation-3"
          round
          @click="toAdd()"
        >
          <v-icon class="pr-1">add</v-icon>
          NEW ADS
        </v-btn>

        <v-layout wrap>
          <v-spacer></v-spacer>
          <v-flex xs12 sm4>
            <v-select
              prepend-icon="mdi-city"
              item-text="province_name_th"
              item-value="province_id"
              v-model="selectedProvinceId"
              :items="provinceData"
              label="Filer by province"
              clearable
            ></v-select></v-flex></v-layout
      ></v-card-title>
      <v-card-text>
        <v-data-table
          :loading="isLoading"
          :headers="headers"
          :items="filteredADSList"
          :expand="true"
          item-key="ads_id"
        >
          <template v-slot:items="props">
            <tr>
              <td @click="props.expanded = !props.expanded">
                {{ adsList.indexOf(props.item) + 1 }}
              </td>
              <td
                @click="props.expanded = !props.expanded"
                class="text-xs-center"
              >
                <span
                  style="
                    background-color: orange;
                    border-radius: 5px;
                    color: white;
                    font-weight: 600;
                  "
                  class="px-2 elevation-3"
                  v-if="props.item.ads_action_type == 'Hyper Link'"
                  >Link</span
                >
                <span
                  style="
                    background-color: #2196f3;
                    border-radius: 5px;
                    color: white;
                    font-weight: 600;
                    white-space: nowrap;
                  "
                  class="px-2 elevation-3"
                  v-else-if="props.item.ads_action_type == 'Food store in app'"
                  >In app</span
                >
                <span
                  style="
                    background-color: red;
                    border-radius: 5px;
                    color: white;
                    font-weight: 600;
                  "
                  class="px-2 elevation-3"
                  v-else
                  >Other</span
                >
              </td>
              <td
                @click="props.expanded = !props.expanded"
                class="text-xs-center pa-2"
              >
                <v-img
                  class="elevation-3"
                  style="width: 150px; height: 84px"
                  :src="props.item.ads_image"
                ></v-img>
              </td>

              <td
                @click="props.expanded = !props.expanded"
                class="text-xs-center"
                style="font-weight: 600"
              >
                {{ props.item.ads_title_th }}
                <div style="color: grey">({{ props.item.ads_title_en }})</div>
              </td>
              <td
                @click="props.expanded = !props.expanded"
                class="text-xs-center"
                style="font-weight: 500"
              >
                {{ props.item.ads_description_th }}
                <div style="color: grey">
                  ({{ props.item.ads_description_en }})
                </div>
              </td>
              <td
                @click="props.expanded = !props.expanded"
                class="text-xs-center"
                style="font-weight: 500"
              >
                {{ props.item.ads_action_name_th }}
                <div style="color: grey">
                  ({{ props.item.ads_action_name_en }})
                </div>
              </td>
              <td
                @click="props.expanded = !props.expanded"
                class="text-xs-center"
                style="color: grey"
              >
                {{ props.item.ads_support_by || "-" }}
              </td>
              <td>
                <v-switch
                  @change="changeStatus(props.item)"
                  color="primary"
                  v-model="props.item.ads_status"
                  hide-details
                ></v-switch>
              </td>
              <td style="white-space: nowrap">
                <v-btn icon @click="toEdit(props.item, props.index)"
                  ><v-icon>edit</v-icon></v-btn
                >
                <v-btn
                  icon
                  @click="deleteItem(props.item.ads_id)"
                  :loading="isDelete"
                  ><v-icon>delete</v-icon></v-btn
                >
              </td>
            </tr>
          </template>
          <template v-slot:expand="props">
            <v-layout wrap v-if="props.item.ads_province.length > []">
              <v-flex
                xs12
                sm4
                class="pa-3"
                v-for="(province, index) in props.item.ads_province"
                :key="index"
              >
                <v-card
                  flat
                  style="border-radius: 10px; border: 1.5px solid #d9d9d9"
                >
                  <v-card-text>
                    <ul>
                      <span style="font-weight: 600">{{
                        province.province_name_th
                      }}</span>

                      <li
                        v-for="(district, index_district) in filterDistrictList(
                          props.item,
                          province.province_id
                        )"
                        :key="index_district"
                      >
                        {{ district.district_name_th }}
                      </li>
                    </ul>
                  </v-card-text>
                </v-card></v-flex
              >
            </v-layout>
            <div
              v-else
              style="display: flex; justify-content: center"
              class="pa-3"
            >
              <v-card
                flat
                style="
                  width: 300px;
                  border-radius: 10px;
                  border: 1.5px solid grey;
                "
              >
                <v-card-text
                  style="font-weight: 600; color: grey"
                  class="text-xs-center"
                >
                  ALL PROVINCE</v-card-text
                >
              </v-card>
            </div>
          </template>
        </v-data-table></v-card-text
      >
    </v-card>
    <WeserveADSForm
      :editedItem="selectedItem"
      :editedIndex="selectedIndex"
      :dialog="formDialog"
      @onClosed="formDialog = false"
    />
  </div>
</template>

<script>
import WeserveADSForm from "@/components/back-office/WeserveADS/WeserveADSForm.vue";
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
        },
        {
          text: "Type",
          align: "center",
          sortable: false,
        },
        {
          text: "Image",
          align: "center",
          sortable: false,
        },

        {
          text: "Title",
          align: "center",
          sortable: false,
        },
        {
          text: "Description",
          align: "center",
          sortable: false,
        },
        {
          text: "Action name",
          align: "center",
          sortable: false,
        },
        {
          text: "Supported by",
          align: "center",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ],

      selectedProvinceId: undefined,
      formDialog: false,
      selectedIndex: -1,
      selectedItem: {},
      isLoading: false,
      isDelete: false,
    };
  },
  components: {
    WeserveADSForm,
  },
  computed: {
    ...mapState({
      adsList: (state) => state.advertising.weserveADSList,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
    filteredADSList() {
      if (this.selectedProvinceId == undefined) return this.adsList;

      return this.adsList.filter(
        (val) =>
          val.ads_province.some(
            (val2) => val2.province_id == this.selectedProvinceId
          ) || val.ads_province.length == 0
      );
    },
  },
  methods: {
    ...mapActions({
      fetchWeserveADSList: "advertising/fetchWeserveADSList",
      updateWeserveADS: "advertising/updateWeserveADS",
      removeWeserveADS: "advertising/removeWeserveADS",
    }),
    filterDistrictList(item, provinceId) {
      return item.ads_district.filter(
        (val) => val.district_province == provinceId
      );
    },
    toEdit(item, index) {
      this.selectedIndex = index;
      this.selectedItem = JSON.parse(JSON.stringify(item));
      this.formDialog = true;
    },
    toAdd() {
      this.formDialog = true;
      this.selectedIndex = -1;
    },
    async deleteItem(ads_id) {
      let result = await confirm("Do you want to delete this ads? ");
      if (result == false) return;
      this.isDelete = true;
      await this.removeWeserveADS(ads_id);
      this.isDelete = false;
    },
    async changeStatus(item) {
      console.log(item);
      let body = JSON.parse(JSON.stringify(item));
      delete body.ads_image;
      body.ads_district = item.ads_district.map((val) => val.district_id);
      body.ads_province = item.ads_province.map((val) => val.province_id);
      // body.ads_store_id = 1;
      // body.ads_hyper_link = ''
      let result = await this.updateWeserveADS(body);
      if (result == false) item.ads_status = !item.ads_status;
    },
  },
  async created() {
    this.isLoading = true;
    await this.fetchWeserveADSList();
    this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped></style>
